import Check from "./Check";
import Elements from "./Elements";
import Entity from "./Entity";
import Filter from "./Filter";
import IdDefinition from "./IdDefinition";
import IdSelect from "./IdSelect";
import NumberProperty from "./NumberProperty";
import OptionsPath from "./OptionsPath";
import OptionsFilter from "./OptionsFilter";
import Payload from "./Payload";
import Regex from "./Regex";
import Sort from "./Sort";
import StringArray from "./StringArray";
import Text from "./Text";
import Validation from "./Validation";
import Search from "./Search";
import Columns from "./Columns";
import ElementBusinessLogic from "./ElementBusinessLogic";
import SearchField from "./SearchField";
import PopulatesFrom from "./PopulatesFrom";
import PopulatesKey from "./PopulatesKey";
import RadioCheck from "./RadioCheck";
import NumberFormat from "./NumberFormat";
import SearchSelectContainer from "components/FormDesigner/elements/SearchSelect/SearchSelectContainer";
import ElementSettings from "./ElementSettings";

export const ComponentMap = {
	boolean: Check,
	elements: Elements,
	entity: Entity,
	filter: Filter,
	idDefinition: IdDefinition,
	idSelect: IdSelect,
	number: NumberProperty,
	optionsId: Entity,
	payload: Payload,
	populatesFrom: PopulatesFrom,
	populatesKey: PopulatesKey,
	optionsPath: OptionsPath,
	optionsFilter: OptionsFilter,
	radio: RadioCheck,
	regex: Regex,
	search: Search,
	sort: Sort,
	stringArray: StringArray,
	string: Text,
	searchField: SearchField,
	validation: Validation,
	elementBusinessLogic: ElementBusinessLogic,
	numberFormat: NumberFormat,
	elementLayout: ElementSettings,
} as const;

export const ValidationMap = {
	number: NumberProperty,
	regex: Regex,
	boolean: Check, // Only used for allowNull, wouldn't work for real boolean in validation
} as const;

export const NumberFormatMap = {
	number: NumberProperty,
	string: SearchSelectContainer,
} as const;

export const SearchMap = {
	idSelect: IdSelect,
	columns: Columns,
	elements: Elements,
	payload: Payload,
};

export const PayloadMap = {
	filter: Filter,
	number: NumberProperty,
	sort: Sort,
	entity: Entity,
} as const;
